import { render, staticRenderFns } from "./getElectricshock5Second.vue?vue&type=template&id=3425e4d6&scoped=true&"
import script from "./getElectricshock5Second.vue?vue&type=script&lang=js&"
export * from "./getElectricshock5Second.vue?vue&type=script&lang=js&"
import style0 from "./getElectricshock5Second.vue?vue&type=style&index=0&id=3425e4d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3425e4d6",
  null
  
)

export default component.exports